import Vue from 'vue'
import VueRouter from 'vue-router'

import login from '../views/login/Login.vue' // 登录
import ResetPsw from '../views/login/ResetPsw.vue' // 重置
import Home from '../views/home/Home.vue' // 首页
import HomeContainer from '../views/home/homeContainer/HomeContainer.vue' // 首页课程列表
import VideoView from '../views/video/VideoView.vue' // 播放页面
import HomeCourse from '../views/home/homeCourse/HomeCourse.vue' // 视频目录

import HomeUser from '../views/home/homeUser/HomeUser.vue' // 首页个人信息
import UserInfo from '../views/home/homeUser/userInfo/UserInfo.vue' // 首页个人信息(个人资料)
import UserRealName from '../views/home/homeUser/userRealName/userRealName' // 首页个人信息(实名认证)
import UseRaccountNumber from '../views/home/homeUser/useRaccountNumber/UseRaccountNumber' // 首页个人信息(实名认证)
import LearningSituation from '../views/home/homeUser/learningSituation/LearningSituation.vue'


/* 课程 */
import Chapter from '../views/home/homeCourse/chapter/Chapter'


Vue.use(VueRouter)

const originalPush = VueRouter.prototype.replace

VueRouter.prototype.replace = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}

const routes = [
    {
        path: '/',
        name: 'login',
        component: login
    },
    {
        path: '/resets',
        name: 'resets',
        component: ResetPsw
    },
    {
        path: '/home',
        name: 'home',
        component: Home,
        redirect: '/homeContainer',
        children: [
            { // 首页
                path: '/homeContainer',
                component: HomeContainer,
            },
            { // 视频目录
                path: '/homeCourse',
                component: HomeCourse,
                redirect: '/homeCourse/chapter',
                children: [
                    {
                        path: 'chapter',
                        component: Chapter,
                        meta: {
                            title: '在线学习系统'
                        }
                    },
                ]
            },
            { // 个人中心
                path: '/homeUser',
                component: HomeUser,
                title: '个人设置',
                redirect: '/homeUser/useRaccountNumber',

                children: [
                    {
                        path: 'useRaccountNumber',
                        component: UseRaccountNumber,
                    },
                    {
                        path: 'userInfo',
                        component: UserInfo,
                    },
                    {
                        path: 'userRealName',
                        component: UserRealName,
                    },
                    {
                        path: 'learningSituation',
                        component: LearningSituation,
                    }
                ]
            }
        ]
    },
    {
        path: '/video',
        name: 'video',
        component: VideoView
    }
    // {
    //     path: '/videoPhoto',
    //     name: 'videoPhoto',
    //     component: videoPhoto
    // }
]


const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})

export default router
